import React from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { SidebarView } from "components/SidebarView";
import { useFeatureFlagStatus } from "hooks/useFeatureFlag";
import { colors, constants } from "utils";
import { WarmUpChallengesHeader, WarmUpChallengesPage } from "./WarmUpChallengesPage";

// The warm-up set picker's route, closed to anyone whose warm_up_challenges
// is off. Only its flag-on branch renders the page, the preview and the modal.

const EmptyMain = styled.div`
  background-color: ${colors.milkGlass500};
  min-height: calc(100vh - 92px);
`;

export const WarmUpPickerRoute = () => {
  const { enabled, isLoading } = useFeatureFlagStatus("warmUpChallenges");

  // Not known yet: hold on the educator chrome rather than bounce a teacher
  // who has the flag.
  if (isLoading) return <SidebarView sideVariant="educator" viewComponent={<EmptyMain />} />;

  if (!enabled) return <Redirect to={constants.EDUCATOR_PATH} />;

  return (
    <SidebarView
      sideVariant="educator"
      viewComponent={<WarmUpChallengesPage />}
      headerTitle={<WarmUpChallengesHeader />}
    />
  );
};
